import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChild, ElementRef, Input } from '@angular/core';
import { CsTooltipComponent } from '../cs-tooltip/cs-tooltip';
import { TranslatedString, untranslatedString } from 'models/translated-string';

@Component({
  selector: 'cs-radio-display',
  templateUrl: 'cs-radio-display.html',
  host: { 'class': 'radio-display' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsRadioDisplayComponent implements AfterContentInit {
  @Input() label: TranslatedString = untranslatedString('');
  @Input() value: string = '';
  @Input() description: TranslatedString = untranslatedString('');
  @Input() customText: string = '';

  @ContentChild(CsTooltipComponent, { read: ElementRef }) tooltipElementRef: ElementRef;

  ngAfterContentInit() {
    // if projected tooltip exists, ensure it has the small attribute
    if (this.tooltipElementRef) {
      (this.tooltipElementRef.nativeElement as HTMLElement).setAttribute('small', '');
    }
  }
}
